import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import AdminChangeUserByVpsComponent from "../../../../components/Admin/vps/AdminChangeUserByVpsComponent";

const AdminChangeUserVpsPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminChangeUserByVpsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default AdminChangeUserVpsPage;